import { render, staticRenderFns } from "./DashboardReportProduct.vue?vue&type=template&id=05b3f5a1&scoped=true"
import script from "./DashboardReportProduct.vue?vue&type=script&lang=js"
export * from "./DashboardReportProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3f5a1",
  null
  
)

export default component.exports